import axios from "axios";
import { TTypeformId } from "../content/types";

export const getUserProgram = async (): Promise<any> =>
  axios
    .get(`${process.env.REACT_APP_API_URL}/user-program`, {
      withCredentials: true,
    })
    .then((response) => response.data);

export const getSectionsUserProgram = async (id: string): Promise<any> =>
  axios
    .get(`${process.env.REACT_APP_API_URL}/user-program/sections/${id}`, {
      withCredentials: true,
    })
    .then((response) => response.data);

export const getDownloadDocumentPatient = async (
  folder: string,
  file: string
) => {
  try {
    const fileName = decodeURIComponent(file);
    const safeFile = encodeURIComponent(fileName);
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/user-program/download_file/${folder}/${safeFile}`,
      {
        withCredentials: true,
        responseType: "blob",
      }
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading file:", error);
    throw new Error();
  }
};

export const createTemporaryLink = async (
  folder: string,
  file: string
): Promise<any> => {
  try {
    const fileName = decodeURIComponent(file);
    const safeFile = encodeURIComponent(fileName);
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/user-program/download_file/${folder}/${safeFile}`,
      {
        withCredentials: true,
        responseType: "blob",
      }
    );
    const url = window.URL.createObjectURL(
      new Blob([response.data], { type: "application/pdf" })
    );

    return url;
  } catch (error) {
    throw new Error(`Error downloading file:, ${error}`);
  }
};

export const deleteFileEmployee = async (id: string): Promise<any> =>
  axios.delete(
    `${process.env.REACT_APP_API_URL}/user-program/document-employee-upload/${id}`,
    {
      withCredentials: true,
    }
  );

export const deleteFilePatient = async (
  patientId: string,
  documentId: string
): Promise<any> => {
  return axios.delete(
    `${process.env.REACT_APP_API_URL}/user-program/sections/${patientId}/document/${documentId}`,
    {
      withCredentials: true,
    }
  );
};
export interface ICreateUserProgramRequest {
  userId: string;
}

type TSubmitHandoutStepRequest = {
  sectionTitle: string;
};

type TSetFormFilledRequest = {
  formID: TTypeformId;
};

export const createUserProgram = async (
  request: ICreateUserProgramRequest
): Promise<any> =>
  axios.post(`${process.env.REACT_APP_API_URL}/user-program`, request, {
    withCredentials: true,
  });

export const submitHandoutStep = async (
  request: TSubmitHandoutStepRequest
): Promise<any> =>
  axios.post(
    `${process.env.REACT_APP_API_URL}/user-program/submit-handout-step`,
    request,
    {
      withCredentials: true,
    }
  );

export const setFormFilled = async (
  request: TSetFormFilledRequest
): Promise<any> =>
  axios.post(
    `${process.env.REACT_APP_API_URL}/user-program/set-form-filled`,
    request,
    {
      withCredentials: true,
    }
  );
